import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'rc-pages',
    templateUrl: './pages.component.html',
    styleUrls: ['./pages.component.css']
})
export class PagesComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {

    }

}
